import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { Subscription } from 'rxjs';
import { Survey, RepliesFilter, RepliesOrder, Question } from '../../../../classes';
import { RepliesService } from '../../../../services';

@Component({
  selector: '[table-header-row]',
  templateUrl: './header-row.component.html',
  styleUrls: ['./header-row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderRowComponent implements OnInit {
  @Input() survey: Survey;
  subscriptions: Subscription[] = [];
  filter: RepliesFilter;
  order: RepliesOrder;
  constructor(
    private repliesService: RepliesService,
    private cdRef: ChangeDetectorRef
  ) {
    this.filter = this.repliesService.filter;
    this.order = this.repliesService.order;
  }

  ngOnInit() {
    this.subscriptions.push(
      this.survey.onContentUpdate.subscribe(() => this.cdRef.detectChanges())
    );
  }
  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  orderBy(type) {
    if (this.order.orderBy === type) {
      this.order.orderDirection =
        this.order.orderDirection === 'desc' ? 'asc' : 'desc';
    } else {
      this.order.orderBy = type;
      this.order.orderDirection = 'asc';
    }
  }
  isFilterOn (question:Question) {
    return question.options.find(o=>this.filter.getOptionShould(o) ? true : false) ? true : false ;
  }
}
